(function ($) {
	$.fn.lmShareDrop = function(options) {
		// NOTE: Don't run logic below if nothing is in the dom
		if (!this.length) {
			return false;
		}
		
		// Default settings are set here
		var settings = $.extend({
			selector: 'has-share-drop'
		}, options);
		
		// These are all the methods available for the plugin
		var methods = {},
		copied = false,
		copiedTimer = false,
		panelPosition;

		methods.setCurrentSettings = function($context) {
			var currentSettings = $context.data();
			if (!$.isEmptyObject(currentSettings)) {	
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}
			// Initialize item
			$context.data('initialized', true);
		}
		
		methods.events = function($context) {

			document.addEventListener('copy', function(event){
				if(event.srcElement.className == "share-drop__input") {
					event.clipboardData.setData('text/plain', location.href);
					event.preventDefault(); // default behaviour is to copy any selected text
				}
			});

			$(document).off('click.lmShareDropPanel').on('click.lmShareDropPanel', '.share-drop', function(event) {
				event.stopPropagation();
			});

			$(document).off('click.lmShareDrop').on('click.lmShareDrop', function(event) {
				var $ele = $(event.target);

				if ($ele.hasClass(settings.selector)) {
					// Click is on button
					if ($ele.hasClass('has-share-drop--show')) {
						// Button has class so now remove
						$ele.addClass('has-share-drop--hide').removeClass('has-share-drop--show');
					} else {
						// Button has no class. remove all others then add class
						$('.has-share-drop--show').addClass('has-share-drop--hide').removeClass('has-share-drop--show');
						$ele.addClass('has-share-drop--show');
						$('.dropdown--open').removeClass('dropdown--closed').removeClass('dropdown--open');
						$('.show-menu').addClass('hide-menu').removeClass('show-menu');
						panelPosition = $ele.offset();

						// If the share panel is off the screen to the right
						if($(window).width() < (panelPosition.left + ($ele.width()/2) + ($ele.find('.share-drop').width()/2))) {
							$ele.addClass('article-card__share--right');
						} else {
							$ele.removeClass('article-card__share--right');
						}

						// If the share panel is off the screen to the left
						if((panelPosition.left + ($ele.width()/2) - ($ele.find('.share-drop').width()/2)) < 0) {
							$ele.addClass('article-card__share--left');
						} else {
							$ele.removeClass('article-card__share--left');
						}
					}
				} else {
					// Click is outside of button, close all drops
					$('.has-share-drop--show').addClass('has-share-drop--hide').removeClass('has-share-drop--show');
				}
			});

			var $shareUrl = $context.find('.share-drop__url');
			$shareUrl.off('click.lmShareDrop').on('click.lmShareDrop', function(event) {
				event.preventDefault();
				event.stopPropagation();

				// Copy
				document.execCommand('copy');

				// Add a class to show acknowledgement. 
				copied = $context.find('.share-drop__copy--copied');
				copied.removeClass('share-drop__copy--copied');

				// Remove the class after 7 seconds
				clearTimeout(copiedTimer);
				copiedTimer = setTimeout(function(){
					copied.addClass('share-drop__copy--copied');
				}, 7000);
			});

			if($context.find('.share-menu').data('text')) {
				var shareText = $context.find('.share-menu').data('text');
			} else {
				var shareText = $('title').text();
			}
			
			$context.find('.share-menu').jsSocials({
				showLabel: false,
				showCount: false,
				shareIn: "popup",
				shares: ["facebook","twitter","email"],
				text: shareText
			});
		}

		methods.initContext = function($context) {
			methods.setCurrentSettings($context);
		}
		
		// Filter each function
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}
		
		// Run once methods when jquery plugin is called
		methods.events(this);
		
		// Methods to run inside loop
		return this.filter(methods.filterEach).each(function() {
			var $this = $(this);
			// NOTE: Method you'd like initialized on a per context basis
			methods.initContext($this);
		});
};

}(jQuery));
